import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTabsModule} from '@angular/material/tabs';
import {RouterModule} from '@angular/router';
import {AltAccessibilityModule, TSESToolbarModule} from '@nh/angular-tses';
import {PermissionsModule} from '../../permissions/permissions.module';
import {ConfirmDialogModule} from './confirm-dialog/confirm-dialog.module';
import {FeedbackDialogModule} from './feedback-dialog/feedback-dialog.module';
import {HeaderComponent} from './header.component';

@NgModule({
  imports: [HeaderModule.IMPORTS, AltAccessibilityModule],
  declarations: HeaderModule.DECLARATIONS,
  exports: HeaderModule.DECLARATIONS
})
export class HeaderModule {
  public static readonly IMPORTS: any[] = [
    CommonModule,
    MatBadgeModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTabsModule,
    RouterModule,
    TSESToolbarModule,
    PermissionsModule,
    MatProgressBarModule,
    FeedbackDialogModule,
    ConfirmDialogModule,
    MatSlideToggleModule
  ];

  public static readonly DECLARATIONS: any[] = [HeaderComponent];
}
